var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.143,
    height: 29.197,
    viewBox: "0 0 16.143 29.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dropdown",
    transform: "translate(0 29.197) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.2.8A1.281,1.281,0,0,1,3,.8L14.1,11.923a1.28,1.28,0,0,0,1.8,0L27,.8a1.281,1.281,0,0,1,1.8,0l.437.434a1.207,1.207,0,0,1,0,1.721L15.9,16.205a1.281,1.281,0,0,1-1.8,0L.762,2.953a1.207,1.207,0,0,1,0-1.721L1.2.8Z",
    transform: "translate(-0.402 -0.43)",
    fill: "#e4a231"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.c09d6e6770226668df3ac60dd10b8d8e.svg";
export { ForwardRef as ReactComponent };